// extracted by mini-css-extract-plugin
module.exports = {"new-video-container":"new-video_new-video-container__3XVKB","form__label":"new-video_form__label__1wdwZ","newVideo__form":"new-video_newVideo__form__13MpD"};